import React, { ChangeEvent } from 'react'
import _ from 'lodash'
import { ISupplyDataVariant } from '@components/Product/VariantKitPanel/VariantKitPanel'

interface Props {
  variants: ISupplyDataVariant[]
  onChange(e: ChangeEvent): void
  selected: number | null
}

const VariantsSelect: React.FC<Props> = ({ variants, onChange, selected }) => {
  const parseObj = obj => {
    let keys = ''
    let values = ''
    _.forIn(obj, (val, key) => {
      keys += `${key} `
      values += `${val} `
    })
    return { keys, values }
  }
  const label = parseObj(variants[0].attributes).keys

  return (
    <div className={`variant-picker ${!selected ? 'not-selected' : ''}`}>
      {label && (
        <>
          <label className='control-label text-bold'>{label}</label>
          <select value={selected} onChange={onChange} className={variants.length === 1 ? 'no-events' : ''}>
            {variants.map(variant => {
              let { values } = parseObj(variant.attributes)
              if (variant.id.toString() === 'click-select') {
                values = variant.variantName || values
              }
              return (
                <option
                  className='variant-picker__option'
                  key={variant.supplyVariantPk}
                  value={variant.supplyVariantPk}
                >
                  {values}
                </option>
              )
            })}
          </select>
        </>
      )}
    </div>
  )
}

export default VariantsSelect
